import { sellerApi } from '@core/api/httpClient'
import { profileEndpointPaths } from './profileEndpointPaths'
import type { ApiEnvelope, SellerProfileDto } from './profileContracts'

export async function getSellerProfile(): Promise<SellerProfileDto> {
  const { data } = await sellerApi.get<ApiEnvelope<SellerProfileDto>>(profileEndpointPaths.SELLER_ME)
  return data.data
}
